var gm = new TimelineMax({paused: true});
var setMotion = function(){
	gm.addLabel('init')
	.from($('.guide_tit'), 0.84, {y: -15, alpha: 0, ease: Power3.easeOut}, "init+=0.8")
	.from($('.guide_txt'), 0.84, {y: 10, alpha: 0, ease: Power3.easeOut}, "init+=1.3")
	.from($('.guide_video'), 0.84, {alpha: 0, ease: Power3.easeInOut}, "init+=1.5");
};
let media = new nc.promokit.Player({
	selector: '#player-guide',
	videoId: 'pWnHflQGcxQ',
	mute: false,
	controls: true,
	coverClick: true
});

let initAnimation = false;

const onStart = () => {

};

const onComplete = () => {

};

const onAnimation = () => {
    $(window).trigger("resize");
	if (!initAnimation) {
		initAnimation = true;
		setMotion();
	}else{
		gm && gm.seek(0);
		gm && gm.pause(0);
	}
	gm.play();
};

const guideRestMedia = () => {
    if(media.state.isPlay){
        media.pause(0);
    }
};

export default {
    onStart,
    onComplete,
    onAnimation,
    guideRestMedia
};



// WEBPACK FOOTER //
// ./src/js/page/guide.js